import { render, staticRenderFns } from "./ItemsAdd.vue?vue&type=template&id=0aceae33&scoped=true"
import script from "./ItemsAdd.vue?vue&type=script&lang=js"
export * from "./ItemsAdd.vue?vue&type=script&lang=js"
import style0 from "./ItemsAdd.vue?vue&type=style&index=0&id=0aceae33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aceae33",
  null
  
)

export default component.exports